import { toast as hotToast } from 'react-hot-toast';

interface ToastOptions {
  duration?: number;
  position?:
    | 'top-left'
    | 'top-center'
    | 'top-right'
    | 'bottom-left'
    | 'bottom-center'
    | 'bottom-right';
}

const defaultStyle = {
  background: '#FFFFFF',
  borderRadius: '16px',
  boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.08)',
  width: '400px',
  minHeight: '72px',
  padding: '16px',
  borderBottom: '4px solid #8276F4',
};

const successStyle = {
  ...defaultStyle,
  color: '#8276F4',
};
const errorStyle = {
  ...defaultStyle,
  color: '#FF4D4F',
  borderBottom: '4px solid #FF4D4F',
};

const infoStyle = {
  ...defaultStyle,
  color: '#4096FF',
  borderBottom: '4px solid #4096FF',
};

const warningStyle = {
  ...defaultStyle,
  color: '#FAAD14',
  borderBottom: '4px solid #FAAD14',
};

const defaultOptions: ToastOptions = {
  duration: 4000,
  position: 'top-center',
};

export const Toast = {
  success(message: string, options?: ToastOptions) {
    return hotToast.success(message, {
      ...defaultOptions,
      ...options,
      style: successStyle,
      iconTheme: {
        primary: '#8276F4',
        secondary: '#FFFFFF',
      },
    });
  },

  error(message: string, options?: ToastOptions) {
    return hotToast.error(message, {
      ...defaultOptions,
      ...options,
      style: errorStyle,
      iconTheme: {
        primary: '#FF4D4F',
        secondary: '#FFFFFF',
      },
    });
  },

  info(message: string, options?: ToastOptions) {
    return hotToast(message, {
      ...defaultOptions,
      ...options,
      style: infoStyle,
      icon: '🔵',
    });
  },

  warning(message: string, options?: ToastOptions) {
    return hotToast(message, {
      ...defaultOptions,
      ...options,
      style: warningStyle,
      icon: '⚠️',
    });
  },

  loading(message: string, options?: ToastOptions) {
    return hotToast.loading(message, {
      ...defaultOptions,
      ...options,
      style: infoStyle,
    });
  },

  dismiss(toastId?: string) {
    hotToast.dismiss(toastId);
  },

  remove() {
    hotToast.remove();
  },
};
